import { createFileRoute } from '@tanstack/react-router';

import { QrGeneratorSelectPage } from '../modules/qr-generator/ui/pages/QrGeneratorSelectPage';

export const Route = createFileRoute('/_authenticated/super-admin/qr-generator/')({
  component: QrGeneratorSelectPage,
  staticData: {
    breadcrumb: ['Platform', 'QR Code Generator'],
  },
});
